module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "0px",
      "padding-top": "35px"
    }
  }, [_c('div', {
    staticClass: "modal deleteConfirmModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.delete))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "background": "#ffffff !important",
      "color": "#000 !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.wanttodeleteadminconfig))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeConfirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal cannotDeleteModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block",
      "border": "0px !important"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "float": "left",
      "width": "90%",
      "margin": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.cannotdeleteconfig))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "background": "#ffffff !important",
      "color": "#000 !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "margin": "-15px"
    }
  }, [_c('div', {
    staticClass: "bc-adduser"
  }, [_c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "15px"
    }
  }, [_c('span', [_vm._v("API Settings")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin": "10px 0px"
    }
  }, [_vm._v("Note: This section is to provide applications to use one cargill APIs.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAppList),
      expression: "showAppList"
    }]
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px 10px"
    }
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    staticClass: "form-control search-app",
    attrs: {
      "placeholder": "Search Application",
      "type": "text",
      "id": "search-criteria"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "border": "1px solid #000",
      "background": "#213031",
      "padding": "10px 10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }, [_vm._v("Applications")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }, [_vm._v("Brand")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _vm._l((_vm.appNameList), function(x, index) {
    return _c('div', {
      key: x.id,
      staticClass: "row searchbox",
      staticStyle: {
        "padding": "5px 10px",
        "border-bottom": "8px solid #eceff1",
        "background-color": "#FFFFFF"
      }
    }, [_c('div', {
      staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "app-name list",
      on: {
        "click": function($event) {
          _vm.getApplicationGroups(_vm.appAdminGroupModal[index].applicationId, index)
        }
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(x.label))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12"
    }, [_c('div', {
      staticClass: "app-name",
      staticStyle: {
        "pointer-events": "none",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.appAdminGroupModal[index].brand))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-12"
    }, [_c('button', {
      staticClass: "deleteconfig",
      on: {
        "click": function($event) {
          _vm.removeRow(_vm.appAdminGroupModal[index].appGrpId, index, _vm.appAdminGroupModal[index].applicationId)
        }
      }
    }, [_vm._v("Delete")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteSuccess),
      expression: "deleteSuccess"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.adminconfigdeletesuccess))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.addConfigRow();
        _vm.changeToAppView()
      }
    }
  }, [_vm._v("Add New App")])])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAppList),
      expression: "!showAppList"
    }]
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 0px",
      "color": "#658d1b",
      "font-weight": "700",
      "background": "#fafafa",
      "width": "100%"
    }
  }, [_vm._v("Application")]), _vm._v(" "), _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].applicationId),
      expression: "appAdminGroupModal[applicationIndex].applicationId"
    }],
    staticClass: "dropdownWrap",
    class: {
      disabledLight: _vm.appAdminGroupModal[_vm.applicationIndex].applicationId !== undefined && _vm.appAdminGroupModal[_vm.applicationIndex].applicationId !== 'undefined' && _vm.appAdminGroupModal[_vm.applicationIndex].groupId !== ''
    },
    attrs: {
      "id": 'select' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.appAdminGroupModal[_vm.applicationIndex].applicationId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getGroups(_vm.appAdminGroupModal[_vm.applicationIndex].applicationId)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectapp))]), _vm._v(" "), _vm._l((_vm.appList), function(j) {
    return (j.name !== 'bookmark') ? _c('option', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.appAdminGroupModal[_vm.applicationIndex].appGrpId === undefined),
        expression: "appAdminGroupModal[applicationIndex].appGrpId === undefined"
      }],
      key: j.id,
      domProps: {
        "value": j.id
      }
    }, [_vm._v(_vm._s(j.label))]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 0px",
      "color": "#658d1b",
      "font-weight": "700",
      "background": "#fafafa",
      "width": "100%"
    }
  }, [_vm._v("Brand")]), _vm._v(" "), _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].brand),
      expression: "appAdminGroupModal[applicationIndex].brand"
    }],
    staticClass: "dropdownWrap",
    class: {
      disabledLight: _vm.appAdminGroupModal[_vm.applicationIndex].applicationId !== undefined && _vm.appAdminGroupModal[_vm.applicationIndex].applicationId !== 'undefined' && _vm.appAdminGroupModal[_vm.applicationIndex].groupId !== ''
    },
    attrs: {
      "id": 'selectbrand' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.appAdminGroupModal[_vm.applicationIndex].brand = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectBrand))]), _vm._v(" "), _vm._l((_vm.brandDetails.data), function(j) {
    return _c('option', {
      key: j.brandKey,
      domProps: {
        "value": j.brandKey
      }
    }, [_vm._v(_vm._s(j.brandName))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 0px",
      "color": "#658d1b",
      "font-weight": "700",
      "background": "#fafafa",
      "width": "100%"
    }
  }, [_vm._v("Allowed Groups")]), _vm._v(" "), _c('span', [_c('div', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "id": "dropdown"
    }
  }, [_c('div', {
    staticClass: "selectDropDown",
    on: {
      "click": function($event) {
        _vm.openDropDown(_vm.applicationIndex)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [(_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId && _vm.appAdminGroupModal[_vm.applicationIndex].subGroupId.length == 0) ? _c('span', [_vm._v(_vm._s(_vm.user_lang['selectgroupslist']))]) : _vm._e(), _vm._v(" "), (_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId && _vm.appAdminGroupModal[_vm.applicationIndex].subGroupId.length > 0) ? _c('span', [_vm._v("Selected (" + _vm._s(_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId ? _vm.appAdminGroupModal[_vm.applicationIndex].subGroupId.length : '0') + ")")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "float": "right",
      "margin": "4px 5px",
      "margin-top": "7px"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropDown[_vm.applicationIndex.toString()]),
      expression: "showDropDown[applicationIndex.toString()]"
    }],
    class: 'ddwrap' + _vm.applicationIndex,
    attrs: {
      "id": "checkboxlist"
    }
  }, [_vm._l((_vm.appsGroups[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId]), function(j) {
    return _c('div', {
      key: j.id,
      staticClass: "dd-list-item",
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px"
      }
    }, [_c('input', {
      staticClass: "form-control input-checkbx-sub",
      attrs: {
        "id": j.id + '~' + _vm.applicationIndex,
        "type": "checkbox"
      },
      domProps: {
        "value": j._embedded.group.profile.name
      },
      on: {
        "change": function($event) {
          _vm.checkchange($event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "vertical-align": "super"
      },
      attrs: {
        "for": j.id
      }
    }, [_vm._v(_vm._s(j._embedded.group.profile.name))])])
  }), _vm._v(" "), _vm._l((_vm.tempAppAdminGroupModal[_vm.applicationIndex].subGroupId), function(j) {
    return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[_vm.tempAppAdminGroupModal[_vm.applicationIndex].applicationId] && (_vm.appGroupsArrayMap[(_vm.tempAppAdminGroupModal[_vm.applicationIndex]).applicationId]).indexOf(j.split('~~~')[0]) === -1) ? _c('div', {
      key: j.id,
      staticClass: "dd-list-item",
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px"
      }
    }, [_c('input', {
      staticClass: "form-control input-checkbx-sub",
      attrs: {
        "id": j.split('~~~')[0] + '~' + _vm.applicationIndex,
        "type": "checkbox"
      },
      domProps: {
        "value": j.split('~~~')[1]
      },
      on: {
        "change": function($event) {
          _vm.checkchange($event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "vertical-align": "super"
      },
      attrs: {
        "for": j.split('~~~')[0]
      }
    }, [_vm._v(_vm._s(j.split('~~~')[1]))])]) : _vm._e()
  })], 2)])]), _vm._v(" "), _vm._l((_vm.appsGroups[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId]), function(j) {
    return (_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId && (_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId).indexOf(j.id + '~~~' + j._embedded.group.profile.name) > -1) ? _c('span', {
      key: j.id,
      staticStyle: {
        "display": "block",
        "padding": "5px"
      }
    }, [_vm._v("-" + _vm._s(j._embedded.group.profile.name))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId), function(j) {
    return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId] && _vm.appGroupsArrayMap[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId].indexOf(j.split('~~~')[0]) === -1) ? _c('span', {
      key: j.id,
      staticStyle: {
        "display": "block",
        "padding": "5px"
      }
    }, [_vm._v("-" + _vm._s(j.split('~~~')[1]))]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-weight": "600",
      "margin-top": "5px"
    }
  }, [_vm._v("Add additional group:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalGroup[_vm.applicationIndex]),
      expression: "additionalGroup[applicationIndex]"
    }],
    staticClass: "addgrouptxtbox",
    attrs: {
      "type": "text",
      "placeholder": "Enter group name and click +"
    },
    domProps: {
      "value": (_vm.additionalGroup[_vm.applicationIndex])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalGroup, _vm.applicationIndex, $event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    staticStyle: {
      "font-size": "20px",
      "cursor": "pointer",
      "color": "rgb(101, 141, 27)",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.addAdditionalGroup(_vm.applicationIndex, _vm.appAdminGroupModal[_vm.applicationIndex].applicationId)
      }
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isIncomplete),
      expression: "isIncomplete"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.adminConfigIncomplete))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saveSuccess),
      expression: "saveSuccess"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.adminconfigupdatesuccess))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "font-size": "17px",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.changeView()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "font-size": "17px",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminGroups()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.save))])])])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-202322ac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-202322ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/APISettings.vue
// module id = 704
// module chunks = 1